module.exports = __webpack_public_path__ + "img/how-to_dapp.0b425405.png";